import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { fireLogger } from '../../core/utils/fire-logger';


@Injectable()
export class AuthSuperAdminGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService:AuthService,
  ) { }

  canActivate() {

    return this.authService.authenticateJwt()
      .then(response => {
        if (response.user.isAdmin !== true  ||  ! ['dretter@retterlaw.com', 'test@firecoding.com'].includes(response.user.email)) {
          fireLogger.log('Not a Super Admin');
          this.authService.logout(false);
          throw new Error('NOT_A_SUPER_ADMIN');
        } else {
          return true;
        }
      })
      .catch(err => {
        if (err.message && err.message == 'NOT_A_SUPER_ADMIN') {
          this.router.navigate(['/login', {err: 'not-super-admin'}]);
        } else {
          this.router.navigate(['/login']);
        }
        return false;
      });

  }
}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/guards/auth-super-admin.guard.ts